// Externe Bibliotheken
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './button.scss';

function Button({ label, classList = '', icon = '', valid = true, validated = false, type, handleClick }) {
    return (
        <button
            type={type}
            onClick={handleClick}
            className={`button-element ${classList} ${valid ? 'valid' : 'invalid'} ${validated ? 'validate' : ''}`}>
            {/* label */}
            {label}

            {/* icon : material-icons */}
            {icon.length > 0 && valid && <i className="material-icons">{icon}</i>}

            {/* loader */}
            {validated && <span className="loader"></span>}
        </button>
    );
}

Button.propTypes = {
    label: PropTypes.string,
    classList: PropTypes.string,
    icon: PropTypes.string,
    valid: PropTypes.bool,
    validated: PropTypes.bool,
    type: PropTypes.oneOf(['text', 'submit', 'reset']),
    handleClick: PropTypes.func,
};

export default Button;
